import React, { useEffect, useState } from "react";
import axiosApi from "../../../../core/interceptor/interceptor";
import { config, REGISTERED_THROUGH_CLEVELAND } from "../../../../config";
import { Disclaimer_Type } from "../../../../Util/helper";
import { useHistory } from "react-router-dom";

function Disclaimer(props) {
	const [disclaimer, setDisclaimer] = useState([]);
	const history = useHistory();

	useEffect(() => {
		axiosApi.get(`${config.apiUrl}/disclaimers/${props?.type}`)
			.then((res) => {
				if (res.data &&
					res.data.data &&
					res.data.data.length >= 0) {
					let temp_disclaimer = [];
					switch (props?.type) {
						case 'Disclaimers':
							temp_disclaimer = res.data.data.filter(obj => ['signUp_disclaimer'].includes(obj?.type));
							break;
						case 'Policies':
							temp_disclaimer = res.data.data.filter(obj => ['covid_policy', 'team_reg_policy'].includes(obj?.type));
							break;
						case 'Notification':
							temp_disclaimer = res.data.data.filter(obj => ['notification_banner'].includes(obj?.type));
							break;
						default: 
							temp_disclaimer = res.data.data.filter(obj => ['site_headline', 'league_headline'].includes(obj?.type));
						break;
					}
					
					setDisclaimer([...temp_disclaimer]);
				}
			})
			.catch((err) => {
				console.error(err)
			})
		// eslint-disable-next-line
	}, []);

	return (
		<div className="content-wrapper sendEmail-wrapper contactUs-wrapper disclaimer-wrapper">
			<div className="header">
				<div className="header-blk common-head-block">
					<h2>{props?.type}</h2>
					<p>
						You can edit {props?.type} for Mulberry and Cleveland.
					</p>
				</div>
			</div>
			{disclaimer.length ? disclaimer.map((x, i) => (
				<div key={i} className="classsifieds">
					<div className="classifieds-left">
						<h5> {Disclaimer_Type[x.type]} ({x.platform === REGISTERED_THROUGH_CLEVELAND ? 'Cleveland' : 'Mulberry'})</h5>
						<p className="disclaimer" dangerouslySetInnerHTML={{
							__html: x.disclaimer,
						}}></p>
						{/* <p className="date-until">Display Until: {moment(x.display_until).format('M/DD/YYYY hh:mm A')}</p> */}
					</div>
					<div className="classifieds-right">
						<span style={{
							color: '00788b',
							textDecoration: 'underline'
						}} onClick={() => (history.push(`/admin/settings/${props?.type === 'Disclaimers' ? 'disclaimer' : (props?.type === 'Headlines' ? 'headline' : (props?.type === 'Notification' ? 'notification-banner' : 'policy'))}/edit?id=${x.id}`))} >Edit</span>
					</div>
				</div>
			)) : ''}
		</div>
	)

}
export default Disclaimer;